export const MESSAGE_ERROR_REQUIRED = 'Pendiente completar todos los campos obligatorios correctamente.'
export const MESSAGE_ERROR_REQUIRED_PROTECTION_DATA = 'Pendiente aceptar la “Política de privacidad”.'
export const MESSAGE_ERROR_PENDING_CONFORMITY = 'Pendiente dar conformidad del requerimiento ingresado.'